import '/app/brewery-packages/content/content-editor-plugin-quote/src/Quote.css-raw';
export default {
  "icon": "jobs-2ec46bc8-icon-D9SRnq",
  "quote": "jobs-2ec46bc8-quote-D9SRnq"
};